/* DARMA PDP gallery (Oct 3 2026). Pairs with snippets/darma-pdp-gallery.liquid.
   - Desktop: thumbnail click swaps the one visible photo in place (no page jump, no viewer).
   - Phone: swipe slider; the thumbnail strip follows the swipe, a thumbnail tap scrolls to it.
   - The photo, "Click to expand" or "Tap to zoom" opens the full-screen viewer at that photo.
   - The Color swatch (.product-form__input--swatch radio) filters every list to its colorway.
   No dependencies. */
(function () {
  'use strict';
  if (window.__darmaPdpGallery) return;
  window.__darmaPdpGallery = true;

  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function handle(v) { return String(v || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function shown(list) { return list.filter(function (el) { return !el.hidden; }); }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].dataset.id === id) return list[i]; return null; }
  function behavior(smooth) { return smooth && !REDUCED.matches ? 'smooth' : 'auto'; }

  /* scroll a scroller (either axis) just enough to show item; never scrolls the page */
  function reveal(scroller, item, smooth) {
    if (!scroller || !item) return;
    var opts = { behavior: behavior(smooth) };
    if (scroller.scrollWidth > scroller.clientWidth + 1) {
      var l = item.offsetLeft, r = l + item.offsetWidth, sl = scroller.scrollLeft, w = scroller.clientWidth;
      if (l < sl) opts.left = l; else if (r > sl + w) opts.left = r - w;
    }
    if (scroller.scrollHeight > scroller.clientHeight + 1) {
      var t = item.offsetTop, b = t + item.offsetHeight, st = scroller.scrollTop, h = scroller.clientHeight;
      if (t < st) opts.top = t; else if (b > st + h) opts.top = b - h;
    }
    if ('left' in opts || 'top' in opts) scroller.scrollTo(opts);
  }

  /* the visible item whose left edge is nearest the scroller's current position */
  function nearest(scroller, items) {
    var best = null, bestD = Infinity, max = scroller.scrollWidth - scroller.clientWidth;
    if (scroller.scrollLeft >= max - 2 && items.length) return items[items.length - 1];
    items.forEach(function (el) {
      var d = Math.abs(el.offsetLeft - scroller.scrollLeft);
      if (d < bestD) { bestD = d; best = el; }
    });
    return best;
  }

  function Gallery(root) {
    var self = this;
    this.root = root;
    this.section = root.closest('.shopify-section') || document;
    this.track = root.querySelector('[data-dpg-track]');
    this.slides = $$('[data-dpg-slide]', root);
    this.thumbs = root.querySelector('[data-dpg-thumbs]');
    this.thumbItems = $$('[data-dpg-thumb-item]', root);
    this.more = root.querySelector('[data-dpg-more]');
    this.lb = root.querySelector('[data-dpg-lb]');
    if (!this.track || !this.lb) return;
    document.body.appendChild(this.lb); /* escape any transformed/sticky ancestor */
    this.lbTrack = this.lb.querySelector('[data-dpg-lb-track]');
    this.lbRail = this.lb.querySelector('[data-dpg-lb-rail]');
    this.lbSlides = $$('[data-dpg-lb-slide]', this.lb);
    this.lbThumbItems = $$('[data-dpg-lb-thumb-item]', this.lb);
    this.prevBtn = this.lb.querySelector('[data-dpg-prev]');
    this.nextBtn = this.lb.querySelector('[data-dpg-next]');
    var first = this.slides.filter(function (s) { return s.classList.contains('is-active'); })[0] || shown(this.slides)[0];
    this.activeId = first ? first.dataset.id : null;
    this.lbId = null;

    /* thumbnails */
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-dpg-thumb]');
      if (t && root.contains(t)) { e.preventDefault(); self.setActive(t.dataset.id, { scroll: true, smooth: true }); return; }
      var o = e.target.closest('[data-dpg-open]');
      if (o && root.contains(o)) { e.preventDefault(); self.open(o.closest('[data-dpg-slide]').dataset.id); return; }
      if (e.target.closest('[data-dpg-expand]')) { e.preventDefault(); self.open(self.activeId); }
    });
    if (this.more) this.more.addEventListener('click', function () {
      self.thumbs.scrollBy({ left: Math.max(120, self.thumbs.clientWidth * 0.8), behavior: behavior(true) });
    });
    if (this.thumbs) this.thumbs.addEventListener('scroll', function () { self.updateMore(); }, { passive: true });

    /* phone swipe → active thumbnail */
    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (DESKTOP.matches || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var s = nearest(self.track, shown(self.slides));
        if (s && s.dataset.id !== self.activeId) self.setActive(s.dataset.id, { scroll: false, smooth: true });
      });
    }, { passive: true });

    /* viewer */
    this.lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-dpg-close]')) { self.close(); return; }
      if (e.target.closest('[data-dpg-prev]')) { self.step(-1); return; }
      if (e.target.closest('[data-dpg-next]')) { self.step(1); return; }
      var t = e.target.closest('[data-dpg-lb-thumb]');
      if (t) self.lbGo(t.dataset.id, true);
    });
    var lbTicking = false;
    this.lbTrack.addEventListener('scroll', function () {
      if (lbTicking) return;
      lbTicking = true;
      requestAnimationFrame(function () {
        lbTicking = false;
        var s = nearest(self.lbTrack, shown(self.lbSlides));
        if (s && s.dataset.id !== self.lbId) self.lbMark(s.dataset.id);
      });
    }, { passive: true });
    this.onKey = function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
      else if (e.key === 'Tab') self.trap(e);
    };

    /* colorway swatch */
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.matches || !input.matches('.product-form__input--swatch input[type="radio"]')) return;
      if (self.section !== document && !self.section.contains(input)) return;
      self.filter(handle(input.value));
    });

    var onMq = function () { self.setActive(self.activeId, { scroll: true, smooth: false }); self.updateMore(); };
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onMq); else if (DESKTOP.addListener) DESKTOP.addListener(onMq);
    window.addEventListener('resize', function () { self.updateMore(); }, { passive: true });
    this.updateMore();
    /* thumbnails are lazy; re-measure once they have size */
    window.addEventListener('load', function () { self.updateMore(); });
  }

  Gallery.prototype.setActive = function (id, o) {
    o = o || {};
    if (!id) return;
    this.activeId = id;
    this.slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.id === id); });
    var thumb = null;
    this.thumbItems.forEach(function (t) {
      var b = t.querySelector('[data-dpg-thumb]');
      if (t.dataset.id === id) { b.setAttribute('aria-current', 'true'); thumb = t; } else b.removeAttribute('aria-current');
    });
    reveal(this.thumbs, thumb, o.smooth);
    if (o.scroll && !DESKTOP.matches) {
      var s = byId(this.slides, id);
      if (s) {
        var max = this.track.scrollWidth - this.track.clientWidth;
        this.track.scrollTo({ left: Math.min(s.offsetLeft, max), behavior: behavior(o.smooth) });
      }
    }
  };

  Gallery.prototype.updateMore = function () {
    if (!this.more || !this.thumbs) return;
    var t = this.thumbs;
    this.more.hidden = !(t.scrollWidth > t.clientWidth + 2 && t.scrollLeft + t.clientWidth < t.scrollWidth - 2);
  };

  Gallery.prototype.filter = function (color) {
    if (!color) return;
    var has = this.slides.some(function (s) { return s.dataset.color === color; });
    var all = this.slides.concat(this.thumbItems, this.lbSlides, this.lbThumbItems);
    all.forEach(function (el) {
      var c = el.dataset.color || '';
      el.hidden = has && c !== '' && c !== color;
    });
    /* labels count only the photos shown, so a screen reader hears 1, 2, 3 */
    [[this.slides, '[data-dpg-open]', ' full screen', 'Open image '], [this.thumbItems, '[data-dpg-thumb]', '', 'Show image '], [this.lbThumbItems, '[data-dpg-lb-thumb]', '', 'Show image ']].forEach(function (x) {
      shown(x[0]).forEach(function (el, i) { el.querySelector(x[1]).setAttribute('aria-label', x[3] + (i + 1) + x[2]); });
    });
    var first = shown(this.slides)[0];
    if (this.thumbs) this.thumbs.scrollLeft = 0;
    if (!DESKTOP.matches) this.track.scrollLeft = 0;
    if (first) this.setActive(first.dataset.id, { scroll: false, smooth: false });
    this.updateMore();
  };

  /* ---------- viewer ---------- */
  Gallery.prototype.open = function (id) {
    if (!id) return;
    this.lastFocus = document.activeElement;
    this.lb.hidden = false;
    this.prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', this.onKey);
    this.lbGo(id, false);
    var c = this.lb.querySelector('[data-dpg-close]');
    if (c) c.focus({ preventScroll: true });
  };

  Gallery.prototype.close = function () {
    if (this.lb.hidden) return;
    this.lb.hidden = true;
    document.documentElement.style.overflow = this.prevOverflow || '';
    document.removeEventListener('keydown', this.onKey);
    if (this.lbId) this.setActive(this.lbId, { scroll: true, smooth: false });
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
  };

  Gallery.prototype.lbGo = function (id, smooth) {
    var s = byId(this.lbSlides, id);
    if (!s) return;
    /* load the photo and its neighbours now instead of waiting for lazy-load */
    var list = shown(this.lbSlides), i = list.indexOf(s);
    [list[i - 1], s, list[i + 1]].forEach(function (el) {
      var img = el && el.querySelector('img');
      if (img && img.loading !== 'eager') img.loading = 'eager';
    });
    this.lbTrack.scrollTo({ left: s.offsetLeft, behavior: behavior(smooth) });
    this.lbMark(id);
  };

  Gallery.prototype.lbMark = function (id) {
    this.lbId = id;
    var thumb = null;
    this.lbThumbItems.forEach(function (t) {
      var b = t.querySelector('[data-dpg-lb-thumb]');
      if (t.dataset.id === id) { b.setAttribute('aria-current', 'true'); thumb = t; } else b.removeAttribute('aria-current');
    });
    reveal(this.lbRail, thumb, true);
    var list = shown(this.lbSlides), i = list.indexOf(byId(this.lbSlides, id));
    if (this.prevBtn) this.prevBtn.disabled = i <= 0;
    if (this.nextBtn) this.nextBtn.disabled = i >= list.length - 1;
  };

  Gallery.prototype.step = function (d) {
    var list = shown(this.lbSlides), i = list.indexOf(byId(this.lbSlides, this.lbId)) + d;
    if (i < 0 || i >= list.length) return;
    this.lbGo(list[i].dataset.id, true);
  };

  Gallery.prototype.trap = function (e) {
    var f = $$('button:not([disabled])', this.lb).filter(function (b) { return b.offsetParent !== null; });
    if (!f.length) return;
    var a = document.activeElement;
    if (e.shiftKey && a === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && a === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  };

  function init() { $$('[data-dpg]').forEach(function (r) { if (!r.__dpg) r.__dpg = new Gallery(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
